import React, { useState, useEffect } from "react";
import { getDataWithComp, useEscapeClose } from "../../../utils/SamuiUtils";
import { useModalKeyboardNavigation, getKeyboardInstructions } from '../../../utils/ModalKeyboardNavigation';

const ApReportModal = ({ showApModal, handleApClose, onRowSelectAp }) => {
    // สถานะการค้นหา
    const [searchTerm, setSearchTerm] = useState("");
    const [apDataList, setApDataList] = useState([]); // State for fetched creditor data
    const [filteredApDataList, setFilteredApDataList] = useState([]);
    const [selectedAps, setSelectedAps] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0); // เพิ่ม state สำหรับเลือกแถว

    useEscapeClose(showApModal, handleApClose);

    // เพิ่ม keyboard navigation
    useModalKeyboardNavigation(
        showApModal,
        filteredApDataList,
        selectedRowIndex,
        setSelectedRowIndex,
        onRowSelectAp,
        handleApClose
    );

    // Fetch creditor data when modal opens
    useEffect(() => {
        if (showApModal) {
            const fetchCreditors = async () => {
                try {
                    const response = await getDataWithComp(
                        "View_Set_AP",
                        "Order By AP_Id"
                    );
                    if (response && response.length > 0) {
                        setApDataList(response);
                        setFilteredApDataList(response); // Initialize filtered list
                    } else {
                        setApDataList([]);
                        setFilteredApDataList([]);
                    }
                } catch (error) {
                    console.error("Error fetching creditor data:", error);
                    setApDataList([]);
                    setFilteredApDataList([]);
                }
            };
            fetchCreditors();
        }
    }, [showApModal]);

    // Filter data when searchTerm changes
    useEffect(() => {
        setFilteredApDataList(
            apDataList.filter(
                (ap) =>
                    ap.AP_Code.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    ap.AP_Name.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, apDataList]);

    // Reset states when modal opens
    useEffect(() => {
        if (showApModal) {
            setSearchTerm("");
            setSelectedAps([]);
            setSelectAll(false);
        }
    }, [showApModal]);

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedAps([]);
        } else {
            setSelectedAps(filteredApDataList);
        }
        setSelectAll(!selectAll);
    };

    const handleSelectAp = (ap) => {
        if (selectedAps.some((selected) => selected.AP_Id === ap.AP_Id)) {
            setSelectedAps(
                selectedAps.filter((selected) => selected.AP_Id !== ap.AP_Id)
            );
        } else {
            setSelectedAps([...selectedAps, ap]);
        }
    };

    const handleConfirm = () => {
        onRowSelectAp(selectedAps);
        handleApClose();
    };

    return (
        <>
            <div
                className={`modal ${showApModal ? "show" : ""}`}
                style={{ display: showApModal ? "block" : "none" }}
                tabIndex="-1"
                role="dialog"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">รายชื่อเจ้าหนี้</h5>
                            <button type="button" className="close" onClick={handleApClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label">ค้นหาเจ้าหนี้</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="ค้นหา รหัสเจ้าหนี้ หรือ ชื่อเจ้าหนี้"
                                            value={searchTerm || ""}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                className="table-responsive mt-3"
                                style={{ maxHeight: "650px", overflowY: "auto" }}
                            >
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: "10%" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectAll}
                                                    onChange={handleSelectAll}
                                                />
                                            </th>
                                            <th className="text-center" style={{ width: "30%" }}>
                                                รหัสเจ้าหนี้
                                            </th>
                                            <th className="text-center" style={{ width: "60%" }}>
                                                ชื่อเจ้าหนี้
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredApDataList && filteredApDataList.length > 0 ? (
                                            filteredApDataList.map((ap, index) => (
                                                <tr
                                                    key={ap.AP_Id || index + 1}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <td className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedAps.some(
                                                                (selected) => selected.AP_Id === ap.AP_Id
                                                            )}
                                                            onChange={() => handleSelectAp(ap)}
                                                        />
                                                    </td>
                                                    <td className="text-center">{ap.AP_Code}</td>
                                                    <td style={{ textAlign: "left" }}>{ap.AP_Name}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3">
                                                    <center>
                                                        <h5>ไม่พบข้อมูล</h5>
                                                    </center>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="text-left" style={{ fontSize: "12px", color: "#666", marginRight: "auto" }}>
                                {getKeyboardInstructions('apreport')}
                            </div>
                            
                            <button
                                className="btn btn-primary"
                                style={{ minWidth: "100px" }}
                                onClick={handleConfirm}
                            >
                                ยืนยัน
                            </button>
                            <button
                                className="btn btn-danger"
                                style={{ minWidth: "100px" }}
                                onClick={handleApClose}
                            > ปิด (ESC)</button>
                        </div>
                    </div>
                </div>
            </div>
            {showApModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default ApReportModal;
